import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IMAGES from "../constants/images";
import { Image } from "react-bootstrap";

const testimonials = [
  {
    text: "Xuthority has transformed the way we manage customer feedback. With real-time tracking, seamless response management, and automation features, we can easily build trust and strengthen our reputation. The intuitive dashboard makes navigating reviews effortless, saving us valuable time.",
    author: "Sarah",
    image: IMAGES.User1_Img,
  },
  {
    text: "Xuthority offers great tools for review monitoring and responding, but some features feel a bit limited. The analytics are helpful, but more customization options would make it even better. Customer support is responsive, which is a plus. Overall, a solid tool, but a few enhancements would make it perfect.",
    author: "Emily",
    image: IMAGES.User2_Img,
  },
  {
    text: "While Xuthority has some useful features, I found it lacking in key integrations with other platforms we use. The interface is decent, but the reporting tools could be more detailed. It’s a decent option for small businesses, but larger companies may need a more advanced solution.",
    author: "Katherine",
    image: IMAGES.User3_Img,
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    centerPadding: "60px", // Add padding to create space between slides
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
    ],
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-slide">
           
            <p className="truncate-8-lines">{testimonial.text}</p>
            <div className="d-flex align-items-center justify-content-between mt-auto">
              <h3>{testimonial.author}</h3>
              <Image
                src={testimonial.image}
                alt=""
                className="img-fluid imgStyleTest"
              />
   
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;
